import React from 'react'
import WrapedSpinner from '../../components/Spinner/WrapedSpinner';
import { currentMonth, currentYear, monthsList, yearsList } from './data';
import { useState } from 'react';
import ReportInfoModal from './ReportInfoModal';
import UserModal from './UserModal';
import { useGetAllReportsQuery } from '../../redux/apiSlices/organizationSlice';
import ReportItem from './ReportItem';


function AllReports() {


	const [reportsFilter, setReportsFilter] = useState({
    year:currentYear,
    month:currentMonth,
    query:''
    })

  const {
	data:reports,
	isFetching
  } = useGetAllReportsQuery(reportsFilter)






  const [selectedReport, setSelectedReport] = useState(null)


  const [showReportInfoModal, setShowReportInfoModal] = useState(false)

  const [showUserModal, setShowUserModal] = useState(false)

  const [query, setQuery] = useState('')

  
  
  

  const handleShowReportInfoModal = (rp) => {
    setSelectedReport(rp)
    setShowReportInfoModal(true)
  }

  const handleShowUserModal = (rp) => {
    setSelectedReport(rp)
    setShowUserModal(true)
  }

  const handlaeSearch = async(e) => {
	e.preventDefault()

	let newReportsFilter = {
		...reportsFilter,
		query: query
	}

	console.log(newReportsFilter)
	setReportsFilter(newReportsFilter)
	
  };

  const handleChange = async(e) => {

	let newReportsFilter = {
		...reportsFilter,
		[e.target.name]: e.target.value
	}

	console.log(newReportsFilter)
	setReportsFilter(newReportsFilter)
	
  };










  return (
	<>
	<ReportInfoModal
      showModal={showReportInfoModal}
      handleCloseModal={()=> setShowReportInfoModal(false)}
      selectedReport={selectedReport}
      />
	<UserModal
      showModal={showUserModal}
      handleCloseModal={()=> setShowUserModal(false)}
      selectedReport={selectedReport}
      />
    <div class="page-content-wrapper border">

		{/* <!-- Title --> */}
		<div class="row mb-3">
			<div class="col-12 d-sm-flex justify-content-between align-items-center">
				<h1 class="h3 mb-2 mb-sm-0">قائمة التقارير</h1>
			</div>
		</div>



		{/* <!-- Card START --> */}
		<div class="card bg-transparent border">

			{/* <!-- Card header START --> */}
			<div class="card-header bg-light border-bottom">
				{/* <!-- Search and select START --> */}
				<div class="row g-3 align-items-center justify-content-end">
					
				<div class="col-md-4 me-auto">
								<form class="position-relative" onSubmit={handlaeSearch}>
									<input 
									class="form-control pe-5  border-0" 
									type="search" 
									placeholder="اسم أو رقم السجل التجاري للمؤسسة" 
									aria-label="Search"
									onChange={(e)=> setQuery(e.target.value)}
									/>
									<button class="bg-transparent px-2 py-0 border-0 position-absolute top-50 end-0 translate-middle-y" type="submit"><i class="fas fa-search fs-6 text-primary"></i></button>
								</form>
							</div>

					<div class="col-md-3">
							<select value={reportsFilter?.month} onChange={handleChange} name='month' class="form-select js-choice border-0 z-index-9" aria-label=".form-select-sm">
                  <option value="" disabled>الشهر</option>
                  <option value="">جميع الشهور</option>
                  {monthsList.map(mn=>(
                    <option key={mn.id} value={mn.number}>{mn.arabicName}</option>
                  ))}
							</select>
					</div>
					{/* <!-- Select option --> */}
					<div class="col-md-3">
							<select value={reportsFilter?.year} onChange={handleChange} name='year' class="form-select js-choice border-0 z-index-9" aria-label=".form-select-sm">
                  <option value="" disabled>السنة</option>
                  <option value="">جميع السنوات</option>
                  {yearsList.map(yr=>(

                    <option key={yr.id} value={yr.year} className='dr-ltr-left'>{yr.year}</option>
                  ))}
							</select>
					</div>


				</div>
				{/* <!-- Search and select END --> */}
			</div>
			{/* <!-- Card header END --> */}

			{/* <!-- Card body START --> */}
			<div class="card-body">
				{/* <!-- Course table START --> */}
				<div class="table-responsive border-0 rounded-3">
					{/* <!-- Table START --> */}
					<table class="table table-dark-gray align-middle p-4 mb-0 table-hover">
						{/* <!-- Table head --> */}
						<thead>
							<tr>
								<th scope="col" class="border-0 rounded-start">اسم المؤسسة</th>
								<th scope="col" class="border-0">عنوان التقرير</th>
								<th scope="col" class="border-0">تاريخ التقديم</th>
								<th scope="col" class="border-0">التفاصيل</th>
							</tr>
						</thead>
							{isFetching ? <tbody><tr><td><WrapedSpinner/></td></tr></tbody> :
						
						<tbody>
							
							{!reports?.length ? 
							<tr><td><p className='my-4 text-center'>لا توجد نتائج للخيارات المحددة</p></td></tr>
               :
              reports?.map((rp,i)=> {
					return (
						<ReportItem
								 key={rp.id}
								 report={rp}
								 handleShowReportInfoModal={handleShowReportInfoModal}
								 handleShowUserModal={handleShowUserModal}
								 />
					)
				
			  })}

			  



						</tbody>
}
						{/* <!-- Table body END --> */}
					</table>
					{/* <!-- Table END --> */}
				</div>
				{/* <!-- Course table END --> */}
			</div>
			{/* <!-- Card body END --> */}


		</div>
		{/* <!-- Card END --> */}
	</div>
	</>
  )
}

export default AllReports